
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/caseStudy2",
      function () {
        return require("private-next-pages/caseStudy2.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/caseStudy2"])
      });
    }
  